import { Link } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'

/**
 * Shown when a user successfully signs in via Supabase Auth but their email
 * isn't on the active members allowlist. Friendly, actionable, no jargon.
 */
const AccessDeniedPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white p-6">
      <div className="text-center max-w-md">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-400/20 border border-amber-300/40 flex items-center justify-center mb-6">
          <ShieldAlert size={28} className="text-amber-300" />
        </div>
        <h1 className="serif-font text-3xl font-bold mb-3">Members only</h1>
        <p className="text-blue-100/90 leading-relaxed mb-8">
          Your sign-in worked, but your email isn't on the Shorewood Association
          member list. If that's a mistake — for example, if the board has you
          under a different address, or you've recently joined — reach out and
          we'll get you set up.
        </p>
        <div className="space-y-3">
          <a
            href="mailto:board@shorewoodmi.com?subject=Portal%20access%20request"
            className="block w-full py-3 px-6 rounded-full bg-white text-blue-900 font-semibold hover:bg-blue-50 transition shadow-lg"
          >
            Email the board
          </a>
          <Link
            to="/"
            className="block w-full py-3 px-6 rounded-full border border-white/40 hover:bg-white/10 transition font-medium"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AccessDeniedPage
